import algoliasearch from 'algoliasearch';
import qs from 'qs';
import { sortOptionsByType } from '@react/data/sortOptions';

const getAlgoliaIndexPrefix = () => process.env.ALGOLIA_ENV_PREFIX;
const getAlgoliaAppId = () => process.env.ALGOLIA_APP_ID;

// locally use stage_
const getAlgoliaIndexNameGlobal = searchType => `${getAlgoliaIndexPrefix()}_${searchType}`;
const getAlgoliaIndexNameColleges = () => `${getAlgoliaIndexPrefix()}_colleges`;
const getAlgoliaIndexNameCompanies = () => `${getAlgoliaIndexPrefix()}_companies`;
const getAlgoliaIndexNameEvents = () => `${getAlgoliaIndexPrefix()}_events`;
const getAlgoliaIndexNameEverything = () => `${getAlgoliaIndexPrefix()}_everything`;
const getAlgoliaIndexNameEventSessions = () => `${getAlgoliaIndexPrefix()}_event_sessions`;
const getAlgoliaIndexNameProperties = () => `${getAlgoliaIndexPrefix()}_properties`;
const getAlgoliaIndexNameMembers = () => `${getAlgoliaIndexPrefix()}_members`;
const algoliaClient = searchAPIKey => algoliasearch(getAlgoliaAppId(), searchAPIKey);
const initSearchClient = (client, trackEmptySearch = false) => ({
    ...client,
    search(requests) {
        const newRequests = requests.map(request => {
            // test for empty string and change request parameter: analytics
            if (!trackEmptySearch && (!request.params.query || request.params.query.length === 0)) {
                request.params.analytics = false;
            }

            return request;
        });

        return client.search(newRequests);
    },
});

export const searchStateToUrl = ({ searchType, sortBy, pageSize, viewType, searchState, includePastEvents }) => {
    let url = `${window.location.pathname}?type=${searchType}`;

    if (sortBy) {
        url += `&sort=${sortBy}`;
    }

    if (pageSize) {
        url += `&perPage=${pageSize}`;
    }

    if (viewType) {
        url += `&view=${viewType}`;
    }

    if (searchType === 'events' && includePastEvents) {
        url += '&past=1';
    }

    delete searchState.configure;
    delete searchState.sortBy;
    delete searchState.type;
    delete searchState.perPage;
    delete searchState.view;

    if (JSON.stringify(searchState) !== JSON.stringify({})) {
        url += `&${qs.stringify(searchState)}`;
    }

    return url;
};

export const urlToSearchState = () => {
    const searchState = qs.parse(window.location.search.slice(1));
    delete searchState.past;

    if (searchState.sort) {
        const sortOptions = sortOptionsByType[searchState.type];
        if (sortOptions) {
            const sortByFromUrl = sortOptions.find(option => option.queryParam === searchState.sort);
            if (sortByFromUrl) {
                searchState.sortBy = `${getAlgoliaIndexNameGlobal(searchState.type)}${sortByFromUrl.indexSuffix}`;
            }
        }

        delete searchState.sort;
    }

    return searchState;
};

export {
    getAlgoliaIndexPrefix,
    getAlgoliaAppId,
    getAlgoliaIndexNameGlobal,
    getAlgoliaIndexNameColleges,
    getAlgoliaIndexNameCompanies,
    getAlgoliaIndexNameEvents,
    getAlgoliaIndexNameEverything,
    getAlgoliaIndexNameEventSessions,
    getAlgoliaIndexNameProperties,
    getAlgoliaIndexNameMembers,
    algoliaClient,
    initSearchClient,
};
